import type { AdCopyJobWithSurveyStatus } from "../../../../../../server/models/ad-copy/job";
import { AdCopySurveyStatus } from "../../../../../../server/models/ad-copy/status";
import type { GetAdCopyJobSearchResponse } from "../../../../../../server/types/request/ad-copy/job";
import type { AdCopyJobSearchAction } from "../../../../types/actions";
import type { MessageInfo } from "../../../../types/info";

type State = GetAdCopyJobSearchResponse & {
	info: MessageInfo;
	loading: boolean;
	result: "empty" | "initial" | "non-empty";
	searches: { [key in keyof AdCopyJobWithSurveyStatus]?: AdCopyJobWithSurveyStatus[key] };
};

export const initState: State = {
	accountOptions: [],
	data: [],
	info: {
		isSuccess: true,
		message: "",
	},
	loading: false,
	result: "initial",
	searches: {},
};

export const reducer = (state: State, action: AdCopyJobSearchAction): State => {
	switch (action.type) {
		case "changeSearches": {
			const searches = { ...state.searches, [action.payload.name]: action.payload.value };

			if (action.payload.value === "") {
				delete searches[action.payload.name];
			}

			return {
				...state,
				searches,
			};
		}

		case "setJob":
			return {
				...state,
				...action.payload,
				loading: false,
				result: action.payload.data.length === 0 ? "empty" : "non-empty",
			};

		case "deleteJob":
			return {
				...state,
				data: state.data
					.map((d) => {
						const jobs = d.jobs.filter((job) => {
							return job._id?.toString() !== action.payload;
						});

						return { ...d, jobs };
					})
					.filter(({ jobs }) => jobs.length > 0),
				info: {
					isSuccess: true,
					message: `削除が完了しました。`,
				},
				loading: false,
			};

		case "changeJobStatus":
			return {
				...state,
				data: state.data.map((d) => {
					const jobs = d.jobs.map((job) => {
						if (job._id?.toString() === action.payload.jobId) {
							return {
								...job,
								status: action.payload.status,
								surveyStatus: action.payload.surveyStatus,
							};
						}

						return job;
					});

					return { ...d, jobs };
				}),
				info: {
					isSuccess: true,
					message: `ステータスを「${AdCopySurveyStatus[action.payload.surveyStatus]}」に変更しました。`,
				},
				loading: false,
			};

		case "changeMessageInfo":
			return {
				...state,
				info: action.payload,
				loading: false,
			};

		case "changeLoading":
			return { ...state, loading: action.payload };
	}
};
